module.exports = __webpack_public_path__ + "static/media/d7ru.e02d391a.pdf";